import {apiClient} from 'common/util/api-client';
import {InsightsBookmarkParams} from 'common/types/reports/bookmark';
import {getProjectId} from 'common/report/util';
import {BookmarkType} from 'common/report/queries/app-api/bookmark-client';

import {appApiUrl} from '../utils';

export type RunBookmarkMigrationsResponse = {
  type: BookmarkType;
  params: InsightsBookmarkParams;
};

export type RunBookmarkMigrationsParams = {
  type: BookmarkType;
  params: InsightsBookmarkParams;
};

export async function runBookmarkMigrations(
  requestParams: RunBookmarkMigrationsParams,
): Promise<RunBookmarkMigrationsResponse> {
  const endpoint = appApiUrl(`run-bookmark-migrations`, {projectId: getProjectId()});
  return apiClient.post<RunBookmarkMigrationsResponse>(endpoint, requestParams);
}
